module.exports = __webpack_public_path__ + "assets/img/homme-femme-numerisation.5433f06a.jpg";